import Hero from "./Hero";
import Services from "./Services";
import Method from "./Method";
import Process from "./Process";
import BeforeAfter from "./BeforeAfter";
import Stats from "./Stats";
import Reviews from "./Reviews";
import Faq from "./Faq";
import CtaBand from "./CtaBand";
import { useSeo } from "../hooks/useSeo";

export const Home = () => {
  useSeo({
    title: "SoftPro | Dak- en gevelreiniging met softwash",
    description:
      "Laat uw dak, gevel, terras of bedrijfspand professioneel reinigen met softwash. Lage druk, een duidelijke offerte en vakkundige uitvoering.",
  });

  return (
    <>
      <Hero />
      <Services />
      <Method />
      <Process />
      <BeforeAfter />
      <Stats />
      <Reviews />
      <Faq />
      <CtaBand />
    </>
  );
};

export default Home;
